export const Resources = {
  menu: "Protein.JTP.MasterData.Menu",
  department: "Protein.JTP.MasterData.Department",
  impersonate: "Protein.JTP.ImpersonateUser",
  notificationTemplate: "Protein.JTP.MasterData.EmailTemplate",
  configuration: "Protein.JTP.MasterData.Configuration",
  widget: "Protein.JTP.MasterData.Widget",
  businessArea: "Protein.JTP.MasterData.BusinessArea",
  businessUnit: "Protein.JTP.MasterData.BusinessUnit",
  division: "Protein.JTP.Goals.Division",
  organization: "Protein.JTP.MasterData.Organization",
  plant: "Protein.JTP.MasterData.Plant",
  personnelArea: "Protein.JTP.MasterData.PersonnelArea",
  position: "Protein.JTP.MasterData.Position",
  positionProfile: "Protein.JTP.MasterData.Position.Critical",
  people: "Protein.JTP.MasterData.People",
  peopleImmigrationType: "Protein.JTP.MasterData.People.ImmigrationType",
  help: "Protein.JTP.Help",
  appCustomization: "Protein.JTP.MasterData.AppCustomization",
  communication: "Protein.JTP.Communication",
  reportMaintenance: "Protein.JTP.Report",
  policy: {
    approvalGroup: "Protein.JTP.Policy.ApprovalGroup",
    attribute: "Protein.JTP.Policy.Attribute",
    policyType: "Protein.JTP.Policy.PolicyType",
    workflow: "Protein.JTP.Policy.Workflow",
    document: "Protein.JTP.Policy.Document",
  },
  threeHundredSixty: {
    form: "Protein.JTP.360.Form",
    formCategory: "Protein.JTP.360.FormCategory",
    questionGroup: "Protein.JTP.360.QuestionGroup",
    questionOption: "Protein.JTP.360.QuestionOption",
    question: "Protein.JTP.360.Question",
    formEmailSender: "Protein.JTP.360.FormEmailSender",
    formPeople: "Protein.JTP.360.FormPeople",
    threeHundredSixtyBUAdmin: "Protein.JTP.360.BAHR",
  },
  expense: {
    expenseReportAdmin: "Protein.JTP.ExpenseReport.Admin",
  },
  talent: {
    talentAdmin: "Protein.JTP.Talent.Admin",
    talentBUAdmin: "Protein.JTP.Talent.BAHR",
  },
  security: {
    securityAdmin: "Protein.JTP.Security.Admin",
  },
  orgChart: {
    orgChartAdmin : "Protein.JTP.OrgChart.Admin",
    orgChartPlantHR : "Protein.JTP.OrgChart.PlantHR",
    orgChartBAHR : "Protein.JTP.OrgChart.BAHR"
  },
  special: {
    isManager : "IsManager"
  }
}
